import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { s } from './EditMyInfo.styles';
import { useNavigate } from 'react-router-dom';
import UserService from '../../../service/User';
import { useUser } from '../../../context/UserContext';
import ConfirmModal from '../ConfirmModal';
import ProfileUpdateModal from '../ProfileUpdateModal';
import MainInquiryPopUp from '../../main/components/MainInquiryPopUpModal';
import { useModal } from '../../../context/ModalContext';
import { logoutCore } from '../../../func/logout';
import DeleteAccountService from '../../../service/deleteAccount/deleteAccount';

interface UserInfo {
  branchcode: number;
  department: string;
  email: string;
  login_type: string;
  name: string;
  notification: string;
  position: string;
  regdate: string;
  state: string;
  tel: string;
  userid: string;
  usertype: string;
  img: string;
  marketing: string;
  info_consent: string;
}

const EditMyInfo = () => {
  const [data, setData] = useState<UserInfo>();
  const [openRequirymenu, setopenRequirymenu] = useState<boolean>(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [title, setTitle] = useState<string>('');
  const [placeholder, setPlaceholder] = useState<string>('');
  const [updateType, setUpdateType] = useState<string>('');
  const [company, setCompany] = useState<string>('');
  const [position, setPosition] = useState<string>('');
  const [showProfileUpdateModal, setShowProfileUpdateModal] = useState(false);
  const [showInquiryPopUp, setShowInquiryPopUp] = useState(false);
  const [inquiryType, setInquiryType] = useState('');
  const [isPushOn, setIsPushOn] = useState<string | undefined>(''); // 푸시 알림 수신 여부 api 데이터 : notification('Y', 'N')
  const [isMarketingOn, setIsMarketingOn] = useState<string | undefined>(''); // 마케팅 수신 여부 api 데이터 : marketing
  const [isThirdPartyOn, setIsThirdPartyOn] = useState<string | undefined>(''); // 제 3자 정보 제공 동의 여부 api 데이터 : info_consent

  const { modalDispatch } = useModal();

  const navigate = useNavigate();

  const { setUser } = useUser();

  const getInfo = async () => {
    try {
      const res = await UserService.userInfo();
      setData(res.data);
      setUser(res.data);
      setIsPushOn(res.data.notification);
      setIsMarketingOn(res.data.marketing);
      setIsThirdPartyOn(res.data.info_consent);
    } catch (error) {
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    if (data) {
      setIsPushOn(data.notification);
      setIsMarketingOn(data.marketing);
      setIsThirdPartyOn(data.info_consent);
    }
  }, [data]);

  const formatPhoneNumber = (tel: string) => {
    return tel.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  };

  const companyInfo = [
    {
      label: '소속',
      value: data?.department,
      changeable: 'Y',
      onClick: () => {
        setTitle('변경할 소속의 정보를 입력해주세요.');
        setPlaceholder('개인 또는 소속된 상호(법인)명을 입력해주세요.');
        setUpdateType('company');
        setOpenConfirmModal(true);
      },
    },
    {
      label: '직함',
      value: data?.position,
      changeable: 'Y',
      onClick: () => {
        setTitle('변경할 직함의 정보를 입력해주세요.');
        setPlaceholder('직함을 입력해주세요.');
        setUpdateType('position');
        setOpenConfirmModal(true);
      },
    },
  ];

  const basicInfo = [
    {
      label: '이메일',
      value: data?.email,
      changeable: 'N',
      onClick: () => {},
    },
    {
      label: '비밀번호',
      value: '********',
      changeable: 'Y',
      onClick: () => {
        navigate('/changePassword');
      },
    },
    {
      label: '휴대폰 번호',
      value: formatPhoneNumber(data?.tel ?? ''),
      changeable: 'Y',
      onClick: () => {
        navigate('/changeContact');
      },
    },
  ];

  const handleLogout = () => {
    logoutCore();
    navigate('/');
  };

  const renderIcon = (type: string) => {
    if (type === 'K') {
      return 'kakao';
    }
    if (type === 'N') {
      return 'naver';
    }
    if (type === 'F') {
      return 'facebook';
    }
    if (type === 'G') {
      return 'google';
    }
  };

  const updateCompanyInfo = async () => {
    try {
      const data = {
        department: company,
        position: position,
        tel: '',
      };
      const res = await UserService.updateUserInfo(data);
      setCompany('');
      setPosition('');
      setOpenConfirmModal(false);
      getInfo();
    } catch (error) {
      console.error('updatePhone 함수에서 에러 발생:', error);
    }
  };

  const updateConsentInfo = async (updateData: Partial<UserInfo>) => {
    try {
      await UserService.updateUserInfo(updateData);
      getInfo();
    } catch (error) {
      console.error('동의 정보 업데이트 중 에러 발생:', error);
    }
  };

  const handlePushToggle = async () => {
    const newValue = isPushOn === 'Y' ? 'N' : 'Y';
    setIsPushOn(newValue);
    await updateConsentInfo({ notification: newValue });
  };

  const handleMarketingToggle = async () => {
    const newValue = isMarketingOn === 'Y' ? 'N' : 'Y';
    setIsMarketingOn(newValue);
    await updateConsentInfo({ marketing: newValue });
  };

  const handleThirdPartyToggle = async () => {
    const newValue = isThirdPartyOn === 'Y' ? 'N' : 'Y';
    setIsThirdPartyOn(newValue);
    await updateConsentInfo({ info_consent: newValue });
  };

  const checkDrawal = async () => {
    try {
      const res = await DeleteAccountService.checkdrawal();
      return res.data.isApplied;
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAccountButton = async () => {
    const isApplied = await checkDrawal();
    if (!isApplied) {
      navigate('/deleteAccount');
    } else {
      window.alert(
        '이미 탈퇴 신청이 접수되었습니다. 처리까지 영업일 기준 2~3일이 소요될 수 있습니다.',
      );
    }
    return;
  };

  return (
    <s.Container>
      <s.Content onClick={() => setopenRequirymenu(false)}>
        <s.ProfileBox>
          <s.ProfileInner>
            <s.ProfileTitle>
              {data?.img ? (
                <img
                  src={`${data.img}?t=${new Date().getTime()}`}
                  alt=""
                  style={{ width: '78px', height: '78px', borderRadius: '50%' }}
                />
              ) : (
                <img src="/assets/images/icon/profile.svg" alt="" />
              )}

              <s.Greeting>
                <s.Name>{data?.name}</s.Name> 님 , 반갑습니다!
              </s.Greeting>
            </s.ProfileTitle>
            <img
              src="/assets/images/icon/meatball.svg"
              alt=""
              style={{ width: '24px', cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();
                setopenRequirymenu(!openRequirymenu);
              }}
            />
            {openRequirymenu && (
              <s.EditBox>
                <s.EditBoxRow
                  style={{
                    borderBottom: '1px solid #E1E2E4',
                  }}
                  onClick={() => {
                    // setInquiryType('Inquiry');
                    // setShowInquiryPopUp(true);
                    modalDispatch({ type: 'I' });
                  }}
                >
                  <span>문의하기</span>
                  <img src="/assets/images/icon/chat.svg" alt="" />
                </s.EditBoxRow>
                <s.EditBoxRow onClick={handleDeleteAccountButton}>
                  <span>회원탈퇴</span>
                  <img src="/assets/images/icon/trashcan.svg" alt="" />
                </s.EditBoxRow>
              </s.EditBox>
            )}
          </s.ProfileInner>
          <s.ChangeProfileButton
            onClick={() => {
              setShowProfileUpdateModal(true);
            }}
          >
            프로필 변경
          </s.ChangeProfileButton>
        </s.ProfileBox>
        {data?.usertype === 'B' && (
          <s.InfoBox>
            <s.InfoTitle>소속정보</s.InfoTitle>
            {companyInfo.map((item, index) => (
              <s.InfoRow key={index}>
                <s.InfoItem>
                  <s.InfoLabel>{item.label}</s.InfoLabel>
                  <span>{item.value}</span>
                </s.InfoItem>
                {item.changeable === 'Y' && (
                  <s.ChangeButton onClick={item.onClick}>변경</s.ChangeButton>
                )}
              </s.InfoRow>
            ))}
          </s.InfoBox>
        )}
        <s.InfoBox>
          <s.InfoTitle>기본정보</s.InfoTitle>
          {basicInfo.map((item, index) => (
            <s.InfoRow key={index}>
              <s.InfoItem>
                <s.InfoLabel>{item.label}</s.InfoLabel>
                <s.EmailInfo>
                  {item.label === '이메일' && data?.login_type !== 'C' && (
                    <img
                      src={`/assets/images/logo/${renderIcon(data?.login_type || '')}.svg`}
                      alt=""
                      style={{ width: '20px', height: '20px' }}
                    />
                  )}

                  {item.value}
                </s.EmailInfo>
              </s.InfoItem>
              {item.changeable === 'Y' && data?.login_type === 'C' && (
                <s.ChangeButton onClick={item.onClick}>변경</s.ChangeButton>
              )}
            </s.InfoRow>
          ))}
        </s.InfoBox>
      </s.Content>
      <s.Content style={{ marginTop: '16px', paddingBottom: '48px' }}>
        <s.InfoBox>
          <s.InfoTitle>혜택∙마케팅 알림</s.InfoTitle>
          <s.InfoRow>
            <s.InfoItem>
              <s.InfoLabel>정보 푸시 알림 수신</s.InfoLabel>
            </s.InfoItem>
            <ToggleWrapper isOn={isPushOn} onClick={handlePushToggle}>
              <ToggleCircle isOn={isPushOn} />
            </ToggleWrapper>
          </s.InfoRow>
          <s.InfoRow>
            <s.InfoItem>
              <s.InfoLabel>마케팅 수신 동의</s.InfoLabel>
            </s.InfoItem>
            <ToggleWrapper isOn={isMarketingOn} onClick={handleMarketingToggle}>
              <ToggleCircle isOn={isMarketingOn} />
            </ToggleWrapper>
          </s.InfoRow>
          <s.InfoRow>
            <s.InfoItem>
              <s.InfoLabel>제3자 정보 제공 동의</s.InfoLabel>
            </s.InfoItem>
            <ToggleWrapper
              isOn={isThirdPartyOn}
              onClick={handleThirdPartyToggle}
            >
              <ToggleCircle isOn={isThirdPartyOn} />
            </ToggleWrapper>
          </s.InfoRow>
        </s.InfoBox>
      </s.Content>
      <s.LogOutButton onClick={handleLogout}>로그아웃</s.LogOutButton>
      {openConfirmModal && (
        <ConfirmModal
          type="edit"
          title={title}
          text=""
          buttonText="변경"
          placeholder={placeholder}
          changeInfo={updateType === 'company' ? company : position}
          setChangeInfo={updateType === 'company' ? setCompany : setPosition}
          onClick={() => {
            updateCompanyInfo();
          }}
          setOpenConfirmModal={setOpenConfirmModal}
        />
      )}
      {showProfileUpdateModal && (
        <ProfileUpdateModal
          setShowProfileUpdateModal={setShowProfileUpdateModal}
          getInfo={getInfo}
        />
      )}

      {showInquiryPopUp && (
        <MainInquiryPopUp
          showInquiryPopUp={showInquiryPopUp}
          setShowInquiryPopUp={setShowInquiryPopUp}
          inquiryType={inquiryType}
        />
      )}
    </s.Container>
  );
};

export default EditMyInfo;

const ToggleWrapper = styled.div<{ isOn: string | undefined }>`
  width: 42px;
  height: 22px;
  border-radius: 999px;
  background-color: ${({ isOn }) =>
    isOn === 'Y' ? '#008AFF' : 'rgba(55, 56, 60, 0.16)'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ToggleCircle = styled.div<{ isOn: string | undefined }>`
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
  transform: ${({ isOn }) =>
    isOn === 'Y' ? 'translateX(10px)' : 'translateX(-10px)'};
`;
